import { Constant } from "../constants";
import { Resource } from "../models/resource.model";


export const generateMkImageLink = (resource: Resource) => {
    return `![${resource.originalName}](${Constant.BASE_URL()}${resource.url} "${resource.originalName}")`;
}